import request from '@/utils/request'
import request2 from '@/utils/export'

export function meetingid(id) {
  return request({
    url: '/meeting/' + id,
    method: 'get'
  })
}
export function meetingsearch(query) {
  return request({
    url: 'meeting/search',
    method: 'post',
    data: query
  })
}
// 会议状态数量统计
export function meetingStatusCount(params) {
  return request({
    url: 'meeting/meetingCount',
    method: 'post',
    data: params
  })
}
// 大杂会任务数量统计
export function taskStatusCount(params) {
  return request({
    url: 'task/taskCount',
    method: 'post',
    data: params
  })
}

export function meetingtask(query) {
  return request({
    url: '/task',
    method: 'post',
    data: query
  })
}
export function meetingcancel(params) {
  return request({
    url: 'meeting/cancel',
    method: 'post',
    data: params
  })
}

export function tasksearch(query) {
  return request({
    url: 'task/search',
    method: 'post',
    data: query
  })
}

export function meetingtasks(query) {
  return request({
    url: 'meeting/tasks',
    method: 'post',
    data: query
  })
}

export function taskdelete(id) {
  return request({
    url: 'task/delete/' + id,
    method: 'get'
  })
}

export function attendeessearch(query) {
  return request({
    url: 'attendees/search',
    method: 'post',
    data: query
  })
}

export function meetingstart(query) {
  return request({
    url: 'meeting/start',
    method: 'post',
    data: query
  })
}
export function meetingend(query) {
  return request({
    url: 'meeting/end',
    method: 'post',
    data: query
  })
}
export function meetingsummary(query) {
  return request({
    url: 'meeting/summary',
    method: 'post',
    data: query
  })
}

export function taskedit(query, id) {
  return request({
    url: 'task/edit/' + id,
    method: 'post',
    data: query
  })
}
export function taskupdate(query, id) {
  return request({
    url: 'task/update/' + id,
    method: 'post',
    data: query
  })
}

export function recordSpeak(query, id) {
  return request({
    url: 'meeting/recordSpeak',
    method: 'post',
    data: query
  })
}

export function getTaskbyId(id) {
  return request({
    url: '/task/' + id,
    method: 'get'
  })
}

export function getHistory(id) {
  return request({
    url: '/task/history/' + id,
    method: 'get'
  })
}

export function meetingupdateOngoing(id, query) { // 进行中的任务调的接口不一样
  return request({
    url: '/meeting/startingEdit/' + id,
    method: 'post',
    data: query
  })
}
export function deleteFile(id) { // 进行中的任务调的接口不一样
  return request({
    url: '/common/delete/' + id,
    method: 'get'
  })
}
export function sendMinutesMeeting(id) { // 发送决议通知
  return request({
    url: '/meeting/sendMinutesMeeting/' + id,
    method: 'get'
  })
}
export function searchLink(data) { //
  return request({
    url: '/meeting/searchLink',
    method: 'post',
    data
  })
}
export function saveLink(data) { //
  return request({
    url: '/meeting/saveLink',
    method: 'post',
    data
  })
}

export function downloadF(id) {
  return request2({
    url: '/common/download/' + id,
    method: 'get'
  })
}
export function sendDingScore(data) {
  return request({
    url: '/meeting/sendDingScore',
    method: 'post',
    data
  })
}
